import { render, staticRenderFns } from "./NewUiPagination.vue?vue&type=template&id=c1ae4610&"
import script from "./NewUiPagination.vue?vue&type=script&lang=ts&"
export * from "./NewUiPagination.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports